



















import { computed, defineComponent } from "@vue/composition-api";
import BaseChip from "@/components/BaseChip";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "ContentFeedCoverGradient",
  components: { BaseChip, BaseIcon },
  props: {
    showErrorIcon: { type: Boolean, default: false },
    showProcessingIcon: { type: Boolean, default: false },
    showScheduledIcon: { type: Boolean, default: false },
    scheduledText: { type: String, default: "" },
  },
  setup(props) {
    const mainIcon = computed(() => {
      if (props.showProcessingIcon) return "sci-processing";
      return "sci-eye-off";
    });

    return { mainIcon };
  },
});
